import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import React from "react";

const HomeDashboard: React.FC = () => {
  // Dados de exemplo para as métricas superiores
  const metricasSuperiores = [
    // Formato de duração do painel: a partir de 24h vem o prefixo de dias
    // ("7D 02:32:00"), igual ao que `utilities/duration.ts` produz nas telas
    // ligadas a dado real. Aqui ainda é mock — não há formatter por trás.
    { label: "Tempo Médio de Fechamento", value: "7D 02:32:00" },
    { label: "Tempo Médio de Resposta", value: "01:48:00" },
    { label: "Total de Falhas", value: "82" },
    { label: "Falhas Internas", value: "53" },
    { label: "Falhas Externas", value: "29" },
  ];
  const acoes = [
    { label: "Ações em Aberto", value: "47" },
    { label: "Ações Planejadas", value: "19" },
    { label: "Ações em Implementação", value: "12" },
    { label: "Ações em Testes", value: "7" },
    { label: "Ações em Espera", value: "9" },
  ];
  const chartData = {
    labels: ["MOTOR A2", "MOTOR A8", "MOTOR B3", "MOTOR C6"],
    datasets: [
      {
        data: [25, 22, 12, 41],
        backgroundColor: ["#00B140", "#71D83F", "#2E7CFA", "#940758"], // Cores aproximadas da imagem
        hoverBackgroundColor: ["#5CB85C", "#9CCC65", "#2E7CFA", "#940758"],
      },
    ],
  };
  const chartOptions = {
    plugins: {
      legend: {
        position: "right", // Posição da legenda como na imagem
      },
      tooltip: {
        // Exibir porcentagens no tooltip
        callbacks: {
          label: function (context: any) {
            let label = context.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed !== null) {
              label += context.parsed + "%";
            }
            return label;
          },
        },
      },
    },
  };

  return (
    <div
      className="text-center flex flex-column justify-content-center align-items-center margin-0"
      style={{ width: "100%" }}
    >
      <div className="text-center w-full mb-4 ">
        <h2 style={{ color: "#4CAF50", fontWeight: "bold" }}>Home/Dashboard</h2>
        <h3 style={{ color: "#66BB6A" }}>Últimos 30 dias</h3>
      </div>

      <div className="flex">
        <Card
          className="col-12"
          style={{
            backgroundColor: "#f1f3f3",
            width: "100%",
            border: "1px solid #e3e5e5",
          }}
        >
          <div className="grid flex">
            {metricasSuperiores.map((metrica, index) => (
              <div
                key={index}
                className="col flex flex-column align-center text-center mb-2"
              >
                <h1
                  className="p-mb-0"
                  style={{ color: "#053238", fontWeight: "bold" }}
                >
                  {metrica.value}
                </h1>
                <span className="p-text-secondary">{metrica.label}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>

      <div className="p-grid p-justify-between flex align-items-center p-mt-4 gap-4">
        <div className="p-col-12 p-md-7 p-mb-4 p-flex">
          <Card
            className="p-d-flex p-flex"
            style={{
              backgroundColor: "#f1f3f3",
              width: "100%",
              border: "1px solid #e3e5e5",
            }}
          >
            <div className="flex justify-content-center gap-2 text-align-center align-items-center text-center">
              <div className="p-col-6 ">
                <h1
                  className="p-mb-0"
                  style={{ color: "#053238", fontWeight: "bold" }}
                >
                  {acoes[0].value}
                </h1>
                <span className="p-text-secondary">{acoes[0].label}</span>
              </div>
              <div className="p-col-6">
                <h1
                  className="p-mb-0"
                  style={{ color: "#053238", fontWeight: "bold" }}
                >
                  {acoes[1].value}
                </h1>
                <span className="p-text-secondary">{acoes[1].label}</span>
              </div>

              <div className="p-col-6">
                <h1
                  className="p-mb-0"
                  style={{ color: "#053238", fontWeight: "bold" }}
                >
                  {acoes[2].value}
                </h1>
                <span className="p-text-secondary">{acoes[2].label}</span>
              </div>
            </div>
            <div className="flex justify-content-center gap-2 text-align-center align-items-center text-center">
              <div className="p-col-6 p-text-center">
                <h1
                  className="p-mb-0"
                  style={{ color: "#053238", fontWeight: "bold" }}
                >
                  {acoes[3].value}
                </h1>
                <span className="p-text-secondary">{acoes[3].label}</span>
              </div>
              <div className="p-col-6 p-text-center">
                <h1
                  className="p-mb-0"
                  style={{ color: "#053238", fontWeight: "bold" }}
                >
                  {acoes[4].value}
                </h1>
                <span className="p-text-secondary">{acoes[4].label}</span>
              </div>
            </div>
          </Card>
        </div>

        <div
          className="mt-4"
          style={{ width: "40%", fontWeight: "bold", aspectRatio: "1 / 1" }}
        >
          <Card
            style={{
              backgroundColor: "#f1f3f3",
              width: "100%",
              height: "100%",
              border: "1px solid #e3e5e5",
              color: "#4CAF50",
            }}
          >
            <h1 style={{ color: "#053238" }}>Falhas por Linha</h1>
            <div style={{ width: "300px", height: "300px" }}>
              <Chart
                type="pie"
                data={chartData}
                options={chartOptions}
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "300px",
                  objectFit: "contain",
                  transform: "translateY(-50px)",
                }}
              />
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default HomeDashboard;
